import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDropDown, CancelButton, StatusWarning } from '_components';
import styles from './Common.module.css'

class ModalityUntimedEntry extends React.Component {

    removeEntry() {
        this.props.removeChildRow(this.props.noteId, 'PTPLANUNTIMEDMODALITIES', 'UM', this.props.entry.UMNO);
    }

    render() {
        return (
            <div className={styles.entry_wrapper}>
                <div className={styles.row}>
                    <DBDropDown
                        noteId={this.props.noteId}
                        entity='PTPLANUNTIMEDMODALITIES'
                        entityKeyColumn='UMNO'
                        entityKeyValue={this.props.entry.UMNO}
                        field='UMMDNO'
                        disabled={this.props.disabled}
                        className={styles.entry_dropdown}
                        customOptions={this.props.options}
                    />
                    {!this.props.disabled &&
                        <div className={styles.remove_button}>
                            <CancelButton title='Remove' size='extra-small' onClick={() => this.removeEntry()} />
                        </div>
                    }
                    {this.props.disabled &&
                        <div className={styles.disabled_flag}>
                            <StatusWarning size='extra-small' title='This code is required in the plan based on the Activity Log' />
                        </div>
                    }
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isFederal = state.entities.admissions[epno].isFederal;
    let isWc = state.entities.admissions[epno].isWc;
    let isAuto = state.entities.admissions[epno].isAuto;
    let isOther = (isPedsEnabled && !isPeds && !isFederal && !isWc && !isAuto) || (!isPedsEnabled && !isFederal && !isWc && !isAuto) ? true : false;
    let options = state.entities.masterData.MLMASTERMODALITIES ?
        Object.keys(state.entities.masterData.MLMASTERMODALITIES)
            .filter(key => {
                if (state.entities.masterData.MLMASTERMODALITIES[key].MDTIMED === false &&
                    ((isPedsEnabled && isPeds && state.entities.masterData.MLMASTERMODALITIES[key].MDPEDS) ||
                        (isFederal && state.entities.masterData.MLMASTERMODALITIES[key].MDMC) ||
                        (isWc && state.entities.masterData.MLMASTERMODALITIES[key].MDWC) ||
                        (isAuto && state.entities.masterData.MLMASTERMODALITIES[key].MDAUTO) ||
                        (isOther && state.entities.masterData.MLMASTERMODALITIES[key].MDOTHER))) {
                    return true;
                } else {
                    return false;
                }
            })
            .sort((a, b) => state.entities.masterData.MLMASTERMODALITIES[a].MDNAME.localeCompare(state.entities.masterData.MLMASTERMODALITIES[b].MDNAME))
            .map(key => (
                {
                    id: state.entities.masterData.MLMASTERMODALITIES[key].MDNO,
                    value: state.entities.masterData.MLMASTERMODALITIES[key].MDNAME + ' - ' + state.entities.masterData.MLMASTERMODALITIES[key].MDCODE
                }
            )) : [];

    let disabled = state.entities.notes.MLMODALITIES &&
        Object.keys(state.entities.notes.MLMODALITIES)
            .find(key => (state.entities.notes.MLMODALITIES[key].XLMDXLNO === xlno &&
                state.entities.notes.MLMODALITIES[key].XLMDPERFORMED === true &&
                state.entities.notes.MLMODALITIES[key].XLMDMDNO === state.entities.notes.PTPLANUNTIMEDMODALITIES[ownprops.id].UMMDNO)) !== undefined ? true : false;

    return {
        noteId,
        entry: state.entities.notes.PTPLANUNTIMEDMODALITIES[ownprops.id],
        options,
        disabled
    };
}

const connectedModalityUntimedEntry = connect(mapStateToProps, mapDispatchToProps)(ModalityUntimedEntry);
export { connectedModalityUntimedEntry as ModalityUntimedEntry };


